import { Component, OnInit, ViewChild , ElementRef } from '@angular/core';
import { RestService } from '../rest.service';
import * as Chart from 'chart.js';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { UserService } from '../user.service';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-ventas',
  templateUrl: './ventas.component.html',
  styleUrls: ['./ventas.component.scss']
})
export class VentasComponent implements OnInit {

  @ViewChild('content', {static: false}) content: ElementRef;

  // PARAMS
  data_disco: any[] = [];
  discotecas = [
    { 'id': '1' , 'nombre': 'LIMOUSINE ELCHE'},
    { 'id': '16' , 'nombre': '5ªAV.ALICANTE '},
    { 'id': '18' , 'nombre': 'LIMOUSINE ALICANTE'},
    { 'id': '19' , 'nombre': '5ª BOULEVARD '},
  ];

  discoteca_id = '';

  chart1;

  table: any[] = [];
  dia: string = this.user.formatDateES(new Date());

  final_data: any = [];

  dateTime: FlatpickrOptions = {
    enableTime: false,
    defaultDate : this.dia,
    locale: Spanish,
    dateFormat: 'd-m-Y',
    onChange: (selectedDates, dateStr, instance) => {
      this.dia = dateStr;
    }
  };

  constructor(
    public rest: RestService,
    public user: UserService,
  ) {}

  ngOnInit() { this.destroyAndBuild(); }

  private mixedChart(nombre, textTitle) {
    return new Chart(document.getElementById(nombre), {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          {
            label: 'HOMBRES',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: true,
            hidden: false
          },
          {
            label: 'MUJERES',
            type: 'line',
            borderColor: '#1ba23e',
            data: [],
            fill: true,
            hidden: false
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true
            },
            ticks: {
              beginAtZero: true
            }
          }]
        },
        events: ['click'],
        legend: {
          display: true,
          labels: {
            boxWidth: 52,
            fontSize: 14
          }
        },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  restAux() {
    this.rest.GetVentas(this.dia, this.discoteca_id).subscribe( (data) => {
      this.table = data['data'].data;
      this.data_disco = data['data']['discotecas'];
      this.chart1.data.labels = data['data'].label;
      //this.zetas = data['data'].zetas;

      for (let index = 0; index < data['data'].datasets.length; index++) {
        this.chart1.data.datasets[index].data = data['data'].datasets[index]
      }

      setTimeout(() => {
        this.chart1.update();
      }, 500);
    });

  }

  destroyAndBuild() {
    if (this.chart1) { this.chart1.destroy(); }
    this.chart1 = this.mixedChart('mix1', 'Entrada de ventas');
    this.restAux();
  }



}
